// extracted by mini-css-extract-plugin
export default {"root":"AvatarPickerButton_root__Oqrn9","label":"AvatarPickerButton_label__Ej7ke","name":"AvatarPickerButton_name__MFQPJ"};